import secureStorage from 'hooks/secureStorage';
const enquete = JSON.parse(secureStorage.getItem('enquete_courante') || '{}');


export const User = {
  /**
   * List of different PAMOFOR Users
   */
  Roles: {
    ADMIN: 'ADMIN',
    ENQUETEUR: 'ENQUETEUR',
    VALIDATEUR: 'VALIDATEUR',
    CQ: 'CQ',
    CD: 'CD',
    COT: 'COT',
  },

  /**
   * return the role of connected user
   * @returns {String}
   */
  get_user_role: () => {
    return secureStorage.getItem('user_role');
  },

  /**
   * Check if the connected user can access to specified ressource.
   * Provide the list of allowed users in array []
   * @param {Array} UserListe
   * @returns {boolean}
   */
  is: (UserListe) => {
    return UserListe?.includes(secureStorage.getItem('user_role'));
  },
};

/**
 * Constante globale au projet
 * Animation de chargement de page
 */
export const loaderStyles = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};

/**
 * Constante globale au projet
 * Type de pièces d'identités
 * CNI || Passeport || attestation || Permis || Autres
 */
export const cinOptionsList = [
  { label: 'Choisir', value: '' },
  { label: 'CNI', value: 'CIN' },
  { label: 'PASSEPORT', value: 'PASSPORT' },
  { label: 'CARTE CONSULAIRE', value: 'CONSULAIRE' },
  { label: "ATTESTATION D'IDENTITE", value: 'ATTESTATION' },
  { label: 'PERMIS DE CONDUIRE', value: 'PERMIS' },
  { label: 'AUTRES', value: 'AUTRES' },
];

export const sexeOptionsList = [
  { label: 'Choisir', value: '' },
  { label: 'Femme', value: 'F' },
  { label: 'Homme', value: 'H' },
];

export const typeSeanceOptionsList = [
  { label: 'Choisir', value: '' },
  {
    label: 'Séance plénière ouverte à tout le village',
    value: 'Séance plénière ouverte à tout le village',
  },
  {
    label: 'Focus group de notables autour du chef de village',
    value: 'Focus group de notables autour du chef de village',
  },
  {
    label: 'Focus group de personnes non originaires du village',
    value: 'Focus group de personnes non originaires du village',
  },
  { label: 'Focus group de femmes', value: 'femmes' },
  { label: 'Focus group de jeunes', value: 'jeunes' },
  { label: 'Focus group de « cadres »', value: 'cadres' },
  {
    label:
      'Focus group d’habitants d’un quartier particulier ou d’un campement',
    value:
      'Focus group d’habitants d’un quartier particulier ou d’un campement',
  },
];

export const Projects = [
  {
    label: 'PAMOFOR PHASE PILOTE',
    value: 'PAMOFOR PHASE PILOTE',
  },
  {
    label: 'PAMOFOR EXTENSION',
    value: 'PAMOFOR EXTENSION',
  },
  {
    label: 'PRESFOR / PASFOR',
    value: 'PRESFOR',
  },
  {
    label: 'PASSFOR',
    value: 'PASSFOR',
  },
];


export const OFDOptionsList = [
  { label: 'Choisir', value: '' },
  { label: 'CGEDS', value: 'CGEDS' },
  { label: '2ATY', value: '2ATY' },
  ...(enquete?.departement === 'FERKESSEDOUGOU' || enquete?.departement === 'SINEMATIALI'
    ? [{ label: 'Le Groupement CGEDS-ETAFAT-TERRABO', value: 'Le Groupement CGEDS-ETAFAT-TERRABO' }]
    : []),
];

export const documentFoncierOptionsList = [
  { label: 'Choisir', value: '' },
  { label: 'Certificat foncier', value: 'Certificat foncier' },
  { label: 'Titre foncier', value: 'Titre foncier' },
  { label: 'Titre de concession', value: 'Titre de concession' },
  { label: "Lettre d'attribution", value: "Lettre d'attribution" },
  { label: 'Autre document officiel', value: 'Autre document officiel' },
];

export const roleSocialOptionsList = [
  { label: 'Choisir', value: '' },
  { label: 'CHEF DE VILLAGE', value: 'CHEF DE VILLAGE' },
  {
    label: 'REPRESENTANT DU CHEF DE VILLAGE',
    value: 'REPRESENTANT DU CHEF DE VILLAGE',
  },
  { label: 'CHEF DE TERRES', value: 'CHEF DE TERRES' },
  {
    label: 'REPRESENTANT DU CHEF DE TERRES',
    value: 'REPRESENTANT DU CHEF DE TERRES',
  },
  {
    label: 'REPRESENTANT DES ALLOCHTONES',
    value: 'REPRESENTANT DES ALLOCHTONES',
  },
  { label: 'REPRESENTANT DES ALLOGENES', value: 'REPRESENTANT DES ALLOGENES' },
  { label: 'NOTABLE', value: 'NOTABLE' },
  { label: 'DIGNITAIRE RELIGIEUX', value: 'DIGNITAIRE RELIGIEUX' },
  {
    label: 'REPRESENTANTE DES FEMMES',
    value: 'REPRESENTANTE DES FEMMES',
  },
  {
    label: 'PRESIDENTE DES FEMMES',
    value: 'PRESIDENTE DES FEMMES',
  },
  {
    label: 'REPRESENTANT DES JEUNES',
    value: 'REPRESENTANT DES JEUNES',
  },
  {
    label: 'PRESIDENT DES JEUNES',
    value: 'PRESIDENT DES JEUNES',
  },
  {
    label: 'SIMPLE MEMBRE DU CVGFR',
    value: 'SIMPLE MEMBRE DU CVGFR',
  },
  {
    label: 'CHEF DE QUARTIER',
    value: 'CHEF DE QUARTIER',
  },
  {
    label: 'CHEF DE CAMPEMENT',
    value: 'CHEF DE CAMPEMENT',
  },
  { label: 'SG CVGFR', value: 'SG CVGFR' },
  { label: 'SG ADJOINT CVGFR', value: 'SG ADJOINT CVGFR' },
  { label: 'AUTRE', value: 'autre' },
];

export const categoriesActeursOptionsList = [
  { label: 'Choisir ', value: '' },
  { label: 'CHEF CANTON', value: 'CHEF CANTON' },
  { label: 'CHEF DE VILLAGE', value: 'CHEF DE VILLAGE' },
  {
    label: 'REPRESENTANT DU CHEF DE VILLAGE',
    value: 'REPRESENTANT DU CHEF DE VILLAGE',
  },
  { label: 'CHEF DE TERRES', value: 'CHEF DE TERRES' },
  {
    label: 'REPRESENTANT DU CHEF DE TERRES',
    value: 'REPRESENTANT DU CHEF DE TERRES',
  },
  { label: 'NOTABLE', value: 'NOTABLE' },
  { label: 'DIGNITAIRE RELIGIEUX', value: 'DIGNITAIRE RELIGIEUX' },
  { label: 'REPRESENTANTE DES FEMMES', value: 'REPRESENTANTE DES FEMMES' },
  { label: 'PRESIDENTE DES FEMMES', value: 'PRESIDENTE DES FEMMES' },
  { label: 'REPRESENTANT DES JEUNES', value: 'REPRESENTANT DES JEUNES' },
  { label: 'PRESIDENT DES JEUNES', value: 'PRESIDENT DES JEUNES' },
  { label: 'MEMBRE DU CVGFR', value: 'MEMBRE DU CVGFR' },
  { label: 'SOUS-PREFET', value: 'SOUS-PREFET' },
  { label: 'COORDINATEUR REGIONAL', value: 'COORDINATEUR REGIONAL' },
  { label: 'COORDINATEUR DEPARTEMENTAL', value: 'COORDINATEUR DEPARTEMENTAL' },
  {
    label: 'CHEF DE BUREAU SOUS-PREFECTORAL',
    value: 'CHEF DE BUREAU SOUS-PREFECTORAL',
  },
  { label: 'COMMISSAIRE-ENQUETEUR', value: 'COMMISSAIRE-ENQUETEUR' },
  { label: 'AGENT ENQUETEUR', value: 'AGENT ENQUETEUR' },
  { label: 'AGENT ISF', value: 'AGENT ISF' },
  {
    label: 'SECRETAIRE ADMINISTRATIF DU SOUS-PREFET',
    value: 'SECRETAIRE ADMINISTRATIF DU SOUS-PREFET',
  },
  { label: 'AUTRE', value: 'AUTRE' },
];

export const categoriesActeursOptionsList01 = [
  { label: 'Choisir', value: '' },
  { label: 'CHEF DE CANTON', value: 'CHEF DE CANTON' },
  { label: 'CHEF DU VILLAGE', value: 'CHEF DU VILLAGE' },
  { label: 'CHEF DE TERRE', value: 'CHEF DE TERRE' },
  { label: 'CHEF DE LIGNAGE', value: 'CHEF DE LIGNAGE' },
  { label: 'CHEF DE GRANDE FAMILLE', value: 'CHEF DE GRANDE FAMILLE' },
  { label: 'CHEF DE QUARTIER', value: 'CHEF DE QUARTIER' },
  { label: 'NOTABLE', value: 'NOTABLE' },
  { label: 'PRESIDENT DU CVGFR', value: 'PRESIDENT DU CVGFR' },
  { label: 'SECRETAIRE DU CVGFR', value: 'SECRETAIRE DU CVGFR' },
  { label: 'MEMBRE DU CVGFR', value: 'MEMBRE DU CVGFR' },
  { label: 'PRESIDENT DES JEUNES', value: 'PRESIDENT DES JEUNES' },
  { label: 'PRESIDENTE DES FEMMES', value: 'PRESIDENTE DES FEMMES' },
  { label: 'CULTIVATEUR', value: 'CULTIVATEUR' },
  { label: 'AGRICULTEUR', value: 'AGRICULTEUR' },
  { label: 'HABITANT', value: 'HABITANT' },
  { label: 'HABITANTE', value: 'HABITANTE' },
  { label: 'CHEF DE COMMUNAUTE', value: 'CHEF DE COMMUNAUTE' },
  { label: 'CHEF COUTUMIER', value: 'CHEF COUTUMIER' },
  { label: 'GUIDE RELIGIEUX', value: 'GUIDE RELIGIEUX' },
  { label: 'PASTEUR', value: 'PASTEUR' },
  { label: 'IMAM', value: 'IMAM' },
  { label: 'AUTRE', value: 'AUTRE' },
];

export const categoriesActeursOptionsList02 = [
  { label: 'Choisir', value: '' },
  { label: 'CHEF DE CANTON', value: 'CHEF DE CANTON' },
  { label: 'CHEF DU VILLAGE', value: 'CHEF DU VILLAGE' },
  { label: 'CHEF DE TERRE', value: 'CHEF DE TERRE' },
  { label: 'CHEF DE QUARTIER', value: 'CHEF DE QUARTIER' },
  { label: 'NOTABLE', value: 'NOTABLE' },
  { label: 'CHEF DE LIGNAGE', value: 'CHEF DE LIGNAGE' },
  { label: 'CHEF DE GRANDE FAMILLE', value: 'CHEF DE GRANDE FAMILLE' },
  { label: 'SACHANT', value: 'SACHANT' },
  { label: 'CULTIVATEUR', value: 'CULTIVATEUR' },
  { label: 'AGRICULTEUR', value: 'AGRICULTEUR' },
  { label: 'HABITANT', value: 'HABITANT' },
  { label: 'HABITANTE', value: 'HABITANTE' },
  { label: 'CHEF DE COMMUNAUTE', value: 'CHEF DE COMMUNAUTE' },
  { label: 'CHEF COUTUMIER', value: 'CHEF COUTUMIER' },
  { label: 'GUIDE RELIGIEUX', value: 'GUIDE RELIGIEUX' },
  { label: 'PASTEUR', value: 'PASTEUR' },
  { label: 'IMAM', value: 'IMAM' },
  { label: 'AUTRE', value: 'AUTRE' },
];

export const categoriesActeursOptionsList03 = [
  { label: 'Choisir', value: '' },
  { label: 'CHEF DE COMMUNAUTE', value: 'CHEF DE COMMUNAUTE' },
  {
    label: 'CHEF DE COMMUNAUTE ALLOCHTONE',
    value: 'CHEF DE COMMUNAUTE ALLOCHTONE',
  },
  {
    label: 'CHEF DE COMMUNAUTE ALLOGENE',
    value: 'CHEF DE COMMUNAUTE ALLOGENE',
  },
  { label: 'CHEF DE QUARTIER', value: 'CHEF DE QUARTIER' },
  { label: 'PRESIDENT D’ASSOCIATION', value: 'PRESIDENT D’ASSOCIATION' },
  { label: 'CULTIVATEUR', value: 'CULTIVATEUR' },
  { label: 'AGRICULTEUR', value: 'AGRICULTEUR' },
  { label: 'HABITANT', value: 'HABITANT' },
  { label: 'HABITANTE', value: 'HABITANTE' },
  { label: 'CHEF COUTUMIER', value: 'CHEF COUTUMIER' },
  { label: 'GUIDE RELIGIEUX', value: 'GUIDE RELIGIEUX' },
  { label: 'PASTEUR', value: 'PASTEUR' },
  { label: 'IMAM', value: 'IMAM' },
  { label: 'AUTRE', value: 'AUTRE' },
];

export const categoriesActeursOptionsList04 = [
  { label: 'Choisir', value: '' },
  { label: 'PRESIDENTE DES FEMMES', value: 'PRESIDENTE DES FEMMES' },
  {
    label: 'PRESIDENTE D’ASSOCIATION DES FEMMES',
    value: 'PRESIDENTE D’ASSOCIATION DES FEMMES',
  },
  { label: 'PRESIDENTE DE COOPERATIVE', value: 'PRESIDENTE DE COOPERATIVE' },
  {
    label: 'PRESIDENTE DE MUTUELLE DE DEVELOPPEMENT DU VILLAGE',
    value: 'PRESIDENTE DE MUTUELLE DE DEVELOPPEMENT DU VILLAGE',
  },
  { label: 'AGRICULTRICE', value: 'AGRICULTRICE' },
  { label: 'CULTIVATRICE', value: 'CULTIVATRICE' },
  { label: 'HABITANTE', value: 'HABITANTE' },
  { label: 'MENAGERE', value: 'MENAGERE' },
  { label: 'AUTRE', value: 'AUTRE' },
];

export const categoriesActeursOptionsList05 = [
  { label: 'Choisir', value: '' },
  { label: 'PRESIDENT DES JEUNES', value: 'PRESIDENT DES JEUNES' },
  { label: 'PRESIDENTE DES FEMMES', value: 'PRESIDENTE DES FEMMES' },
  { label: 'PRESIDENT (E) DE MUTUELLE', value: 'PRESIDENT (E) DE MUTUELLE' },
  {
    label: 'PRESIDENT (E) DE COOPERATIVE',
    value: 'PRESIDENT (E) DE COOPERATIVE',
  },
  {
    label: 'PRESIDENT (E) D’ASSOCIATION DES JEUNES',
    value: 'PRESIDENT (E) D’ASSOCIATION DES JEUNES',
  },
  { label: 'PRESIDENT DU CVGFR', value: 'PRESIDENT DU CVGFR' },
  { label: 'SECRETAIRE DU CVGFR', value: 'SECRETAIRE DU CVGFR' },
  { label: 'MEMBRE DU CVGFR', value: 'MEMBRE DU CVGFR' },
  { label: 'CULTIVATEUR', value: 'CULTIVATEUR' },
  { label: 'AGRICULTEUR', value: 'AGRICULTEUR' },
  { label: 'HABITANT', value: 'HABITANT' },
  { label: 'HABITANTE', value: 'HABITANTE' },
  { label: 'CHEF DE COMMUNAUTE', value: 'CHEF DE COMMUNAUTE' },
  { label: 'AUTRE', value: 'AUTRE' },
];

export const categoriesActeursOptionsList06 = [
  { label: 'Choisir', value: '' },
  {
    label: 'PRESIDENT(E) DE LA MUTUELLE DE DEVELLOPEMENT DU VILLAGE',
    value: 'PRESIDENT(E) DE LA MUTUELLE DE DEVELLOPEMENT DU VILLAGE',
  },
  {
    label: 'PRESIDENT (E) DE COOPERATIVE',
    value: 'PRESIDENT (E) DE COOPERATIVE',
  },
  {
    label: 'PRESIDENT (E) D’ASSOCIATION',
    value: 'PRESIDENT (E) D’ASSOCIATION',
  },
  { label: 'DEPUTE', value: 'DEPUTE' },
  { label: 'MAIRE', value: 'MAIRE' },
  { label: 'ADJOINT AU MAIRE', value: 'ADJOINT AU MAIRE' },
  {
    label: 'PRESIDENT DU CONSEIL REGIONAL',
    value: 'PRESIDENT DU CONSEIL REGIONAL',
  },
  {
    label: 'VICE PRESIDENT DU CONSEIL REGIONAL',
    value: 'VICE PRESIDENT DU CONSEIL REGIONAL',
  },
  { label: 'PREFET', value: 'PREFET' },
  { label: 'SOUS-PREFET', value: 'SOUS-PREFET' },
  { label: 'GENDARME', value: 'GENDARME' },
  { label: 'POLICIER', value: 'POLICIER' },
  { label: 'PROFESSEUR', value: 'PROFESSEUR' },
  { label: 'ENSEIGNANT', value: 'ENSEIGNANT' },
  { label: 'INSTITUTEUR', value: 'INSTITUTEUR' },
  { label: 'AUTRE', value: 'AUTRE' },
];

export const categoriesActeursOptionsList07 = [
  { label: 'Choisir', value: '' },
  { label: 'CHEF DU VILLAGE', value: 'CHEF DU VILLAGE' },
  { label: 'CHEF DE TERRE', value: 'CHEF DE TERRE' },
  { label: 'CHEF DE QUARTIER', value: 'CHEF DE QUARTIER' },
  { label: 'PRESIDENT DES JEUNES', value: 'PRESIDENT DES JEUNES' },
  { label: 'PRESIDENTE DES FEMMES', value: 'PRESIDENTE DES FEMMES' },
  { label: 'CULTIVATEUR', value: 'CULTIVATEUR' },
  { label: 'AGRICULTEUR', value: 'AGRICULTEUR' },
  { label: 'HABITANT', value: 'HABITANT' },
  { label: 'HABITANTE', value: 'HABITANTE' },
  { label: 'CHEF DE COMMUNAUTE', value: 'CHEF DE COMMUNAUTE' },
  { label: 'CHEF COUTUMIER', value: 'CHEF COUTUMIER' },
  { label: 'GUIDE RELIGIEUX', value: 'GUIDE RELIGIEUX' },
  { label: 'PASTEUR', value: 'PASTEUR' },
  { label: 'IMAM', value: 'IMAM' },
  { label: 'AUTRE', value: 'AUTRE' },
];

export const lieuOptionsList = [
  { label: 'Choisir', value: '' },
  { label: 'PLACE PUBLIQUE', value: 'PLACE PUBLIQUE' },
  { label: 'COUR DU CHEF DE VILLAGE', value: 'COUR DU CHEF DE VILLAGE' },
  {
    label: "SOUS L'ARBRE A PALABRE DU VILLAGE",
    value: "SOUS L'ARBRE A PALABRE DU VILLAGE",
  },
  { label: 'ECOLE PRIMAIRE DU VILLAGE', value: 'ECOLE PRIMAIRE DU VILLAGE' },
  { label: 'COLLEGE DU VILLAGE', value: 'COLLEGE DU VILLAGE' },
  { label: 'AUTRE', value: 'AUTRE' },
];

export const fonctionOptionsList = [
  { label: 'Choisir', value: '' },
  { label: 'Président CVGFR', value: 'Président CVGFR' },
  { label: 'Vice-président CVGFR', value: 'Vice-président CVGFR' },
  { label: 'Secrétaire CVGFR', value: 'Secrétaire CVGFR' },
  { label: 'Secrétaire Adjoint CVGFR', value: 'Secrétaire Adjoint CVGFR' },
  { label: 'Trésorier CVGFR', value: 'Trésorier CVGFR' },
  { label: 'Trésorier Adjoint CVGFR', value: 'Trésorier Adjoint CVGFR' },
  { label: 'Président des jeunes', value: 'Président des jeunes' },
  { label: 'Présidente des femmes', value: 'Présidente des femmes' },
  { label: 'Membre CVGFR', value: 'Membre CVGFR' },
  { label: 'Chef du Village', value: 'Chef du Village' },
  { label: 'Chef de Terre', value: 'Chef de Terre' },
  { label: 'Membre Chefferie', value: 'Membre Chefferie' },
  { label: 'Notable', value: 'Notable' },
  { label: 'Guide religieux', value: 'Guide religieux' },
  { label: 'Président de mutuelle', value: 'Président de mutuelle' },
  { label: 'Sous-préfet', value: 'SOUS-PREFET' },
  { label: 'Coordinateur départemental', value: 'COORDINATEUR DEPARTEMENTAL' },
  {
    label: 'Chef de bureau sous-préfectoral',
    value: 'CHEF DE BUREAU SOUS-PREFECTORAL',
  },
  { label: 'Commissaire-enquêteur', value: 'COMMISSAIRE-ENQUETEUR' },
  { label: 'Agent enquêteur', value: 'AGENT ENQUETEUR' },
  { label: 'Agent ISF', value: 'AGENT ISF' },
  {
    label: 'Secrétaire administratif du sous-préfet',
    value: 'SECRETAIRE ADMINISTRATIF DU SOUS-PREFET',
  },
  { label: 'Autre', value: 'Autre' },
];

export const qualiteOptionsList = [
  { label: 'Choisir', value: '' },
  { label: 'Président CVGFR', value: 'Président CVGFR' },
  { label: 'Vice-président CVGFR', value: 'Vice-président CVGFR' },
  { label: 'Secrétaire CVGFR', value: 'Secrétaire CVGFR' },
  { label: 'Secrétaire Adjoint CVGFR', value: 'Secrétaire Adjoint CVGFR' },
  { label: 'Trésorier(ere) CVGFR', value: 'Trésorier(ere) CVGFR' },
  {
    label: 'Trésorier(ere) Adjoint CVGFR',
    value: 'Trésorier(ere) Adjoint CVGFR',
  },
  { label: 'Membre CVGFR', value: 'Membre CVGFR' },
  { label: 'Autre', value: 'Autre' },
];

export const serviceOptionsList = [
  { label: 'CERTIFICATION FONCIÈRE', value: 'DCF' },
  // { label: "CONTRATS", value: "CONTRATS" },
];

export const csvNationalitesPath = '../donnees/nationalites.csv';

export const CommissaireEnq = {
  Signature:
    secureStorage.getItem('signature_com_enq') &&
    secureStorage.getItem('signature_com_enq') !== 'undefined' &&
    secureStorage.getItem('signature_com_enq') !== 'null' ? (
      <div className="flex flex-col px-3 items-end justify-center w-full">
        <img
          className="object-scale-down h-15 w-15"
          src={secureStorage.getItem('signature_com_enq')}
          alt="Signature commissaire Enq"
        />
      </div>
    ) : null,
};

export const CommissaireEnqSignature =
  secureStorage.getItem('signature_com_enq') || null;

export const MESSAGES = {
  SUCCESS: 'RESSOURCE CREEE AVEC SUCCES',
  CONFIRMATION_TRANSMISSION: 'La ressource a été transmise avec succès.',
  ERROR_TRANSMISSION: "une erreur s'est produite.",
  SEND: "CONFIRMER L'ENVOI ?",
  SEND_TRANSMISSION: 'Êtes-vous sûr de vouloir transmettre cette demande?',
  SEND_TRANSMISSION_ENQUETE:
    'Êtes-vous sûr de vouloir transmettre cette enquete?',
  ERROR: "UNE ERREUR S'EST PRODUITE, VOTRE REQUETE N'A PAS ABOUTI",
  LOADIND: 'REQUETE EN COURS..., VEUILLEZ PATIENTEZ',
  QUIT: 'VOULEZ-VOUS QUITTER ?',
  CONFIRMATION_SUPPRESSION: 'VOULEZ-VOUS SUPPRIMER CETTE RESSOURCE ?',
  SIGNATURE_MODIFICATION:
    'ENREGISTREMENT AVEC SUCCÈS, SUITE À CETTE MODIFICATION VOTRE SIGNATURE SERA AFFECTÉE AU LIVRABLE',
};

export const MSG_CF = {
  CREATE: "Confirmer l'enregistrement ?",
  CREATE_INPART: (
    <>
      <div className="flex flex-col gap-5 items-center justify-start w-full">
        <div className="flex flex-col items-center justify-start w-full">
          <p
            className="text-cyan-900 text-center text-base w-full"
            size="txtInterRegular"
          >
            L'annonce de publicité sera créée avec seulement les demandes ayant
            la résidence renseignée.
          </p>
          <br />
          <p
            className="text-blue_gray-800_01 text-left text-base w-full"
            size="txtInterRegular"
          >
            Si vous voulez continuer, Confirmer l'enregistrement.
          </p>
          <p
            className="text-blue_gray-800_01 text-left text-base w-full"
            size="txtInterRegular"
          >
            Sinon, Annuler et quitter pour renseigner les informations de
            résidence sur les demandes concernées. Puis revenir à nouveau pour
            créer l'annonce de publicité.
          </p>
        </div>
      </div>
    </>
  ),
  // CREATE_INPART:
  //   "L'annonce de publicité sera créée avec seulement les demandes ayant la résidence renseignée.\n\n" +
  //   "Si vous voulez continuer, Confirmer l'enregistrement.\n\n" +
  //   "Sinon, Annuler et quitter pour renseigner les informations de résidence sur les demandes concernées. Puis revenir à nouveau pour créer l'annonce de publicité.",
  ADDITIONAL_DCF: 'Voulez-vous ajouter la liste des nouvelles demandes ?',
  CONFIRM_PVPUB:
    'Tous les champs sont correctement renseignés.\n\n' +
    'Quittez cette fenêtre et cliquez sur le bouton Enregistrer pour enregistrer le PV de clôture de publicité.',
  ERROR:
    "Erreur survenue. Veuillez contacter l'administrateur ou réessayer plus tard!",
  ERROR_QUIT:
    "Livrable enregistré mais tous les éléments de la liste annexe n'ont pas été bien enregistrés. Veuillez contacter l'administrateur ou réessayer plus tard!",
  QUIT: 'Voulez-vous quitter sans enregistrer? Toutes les informations saisies seront perdues!',
  SAVE_DRAFT:
    'Voulez-vous sauvegarder ce formulaire comme brouillon avant de quitter?',
  CONTINUE_WITH_DRAFT:
    'Une sauvegarde existe déjà pour ce livrable. Voulez-vous continuer avec la sauvegarde existante ou reprendre une nouvelle saisie ?',
};

export const dureeUnitOptionsList = [
  { label: 'Choisir', value: '' },
  { label: 'Jours', value: 'JOURS' },
  { label: 'Semaines', value: 'SEMAINES' },
  { label: 'Mois', value: 'MOIS' },
  { label: 'Années', value: 'ANNEES' },
  { label: 'Campagne agricole', value: 'CAMPAGNE AGRICOLE' },
];
